/* Doux Souffle – interactions légères, sans dépendance */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Apparition au défilement */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-ds-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Animations SVG coupées si l'utilisateur préfère moins de mouvement */
  function pauseSvg(root) {
    if (!reduce) return;
    (root || document).querySelectorAll('svg').forEach(function (s) { if (s.pauseAnimations) s.pauseAnimations(); });
  }

  /* Onglets génériques : [data-ds-tabs] > [data-ds-tab] + [data-ds-panel] */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-ds-tabs]').forEach(function (wrap) {
      if (wrap.dataset.dsReady) return; wrap.dataset.dsReady = '1';
      var tabs = wrap.querySelectorAll('[data-ds-tab]');
      var panels = wrap.querySelectorAll('[data-ds-panel]');
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          t.tabIndex = j === i ? 0 : -1;
          if (j === i && focus) t.focus();
        });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(n, true);
          }
        });
      });
    });
  }

  /* FAQ : filtre par catégorie */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-ds-faq]').forEach(function (faq) {
      if (faq.dataset.dsReady) return; faq.dataset.dsReady = '1';
      var btns = faq.querySelectorAll('[data-ds-cat]');
      var items = faq.querySelectorAll('[data-ds-item]');
      if (!btns.length) return;
      function show(cat) {
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.dsCat === cat ? 'true' : 'false'); });
        var first = true;
        items.forEach(function (it) {
          var on = cat === 'all' || it.dataset.dsItem === cat;
          it.hidden = !on;
          it.open = on && first && it.dataset.dsOpenFirst === '1';
          if (on) first = false;
        });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.dsCat); }); });
      show(btns[0].dataset.dsCat);
    });
  }

  /* Vidéos : chargement du lecteur au clic (page plus rapide) */
  function initVideos(root) {
    (root || document).querySelectorAll('[data-ds-video]').forEach(function (btn) {
      if (btn.dataset.dsReady) return; btn.dataset.dsReady = '1';
      btn.addEventListener('click', function () {
        var frame = btn.parentElement;
        var type = btn.dataset.dsVideo;
        if (type === 'tiktok') {
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.tiktok.com/player/v1/' + btn.dataset.id + '?autoplay=1&loop=1&rel=0&music_info=0&description=0';
          iframe.title = btn.getAttribute('aria-label') || 'Vidéo TikTok';
          iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          frame.appendChild(iframe);
        } else {
          var tpl = frame.querySelector('template');
          if (tpl) {
            frame.appendChild(tpl.content.cloneNode(true));
            var v = frame.querySelector('video');
            if (v) { v.play && v.play().catch(function () {}); }
          }
        }
        btn.remove();
      });
    });
  }

  /* Estimation de livraison en jours ouvrés (jours fériés français inclus) */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  function holidays(y) {
    var e = easter(y), add = function (d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; };
    return [new Date(y, 0, 1), add(e, 1), new Date(y, 4, 1), new Date(y, 4, 8), add(e, 39), add(e, 50),
      new Date(y, 6, 14), new Date(y, 7, 15), new Date(y, 10, 1), new Date(y, 10, 11), new Date(y, 11, 25)]
      .map(function (d) { return d.toDateString(); });
  }
  function addBusinessDays(start, n) {
    var d = new Date(start), added = 0, hol = holidays(d.getFullYear()).concat(holidays(d.getFullYear() + 1));
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6 && hol.indexOf(d.toDateString()) === -1) added++;
    }
    return d;
  }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-ds-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 3, max = parseInt(el.dataset.max, 10) || 4;
      var now = new Date();
      var a = addBusinessDays(now, min), b = addBusinessDays(now, max);
      var out = el.querySelector('[data-ds-delivery-dates]');
      var txt;
      if (el.dataset.format === 'short') {
        var mS = new Intl.DateTimeFormat('fr-FR', { month: 'short' });
        txt = a.getMonth() === b.getMonth()
          ? 'entre le ' + a.getDate() + ' et le ' + b.getDate() + ' ' + mS.format(b)
          : 'entre le ' + a.getDate() + ' ' + mS.format(a) + ' et le ' + b.getDate() + ' ' + mS.format(b);
      } else {
        var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
        txt = 'entre le ' + fmt.format(a) + ' et le ' + fmt.format(b);
      }
      if (out) out.textContent = txt;
    });
  }

  /* Calculateur toiletteur */
  function initCalc(root) {
    (root || document).querySelectorAll('[data-ds-calc]').forEach(function (calc) {
      if (calc.dataset.dsReady) return; calc.dataset.dsReady = '1';
      var price = parseFloat(calc.dataset.price) || 189;
      var state = { min: 55, max: 70, freq: 6 };
      var euro = function (n) { return Math.round(n).toLocaleString('fr-FR') + ' €'; };
      function render() {
        var low = state.min * state.freq, high = state.max * state.freq;
        var n = Math.ceil(price / ((state.min + state.max) / 2));
        calc.querySelector('[data-ds-out="range"]').textContent = state.min + ' à ' + state.max + ' €';
        calc.querySelector('[data-ds-out="yearly"]').textContent = euro(low) + ' à ' + euro(high) + ' par an';
        calc.querySelector('[data-ds-out="n"]').textContent = n;
        calc.querySelector('[data-ds-out="bar"]').style.width = Math.max(10, Math.round(price / high * 100)) + '%';
      }
      calc.querySelectorAll('[data-ds-size]').forEach(function (b) {
        b.addEventListener('click', function () {
          calc.querySelectorAll('[data-ds-size]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var p = b.dataset.dsSize.split('-'); state.min = +p[0]; state.max = +p[1]; render();
        });
      });
      calc.querySelectorAll('[data-ds-freq]').forEach(function (b) {
        b.addEventListener('click', function () {
          calc.querySelectorAll('[data-ds-freq]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          state.freq = +b.dataset.dsFreq; render();
        });
      });
      var s = calc.querySelector('[data-ds-size][aria-pressed="true"]');
      if (s) { var p = s.dataset.dsSize.split('-'); state.min = +p[0]; state.max = +p[1]; }
      var f = calc.querySelector('[data-ds-freq][aria-pressed="true"]');
      if (f) state.freq = +f.dataset.dsFreq;
      render();
    });
  }

  /* Navigation d'ancres : surligne la section visible */
  function initAnchors() {
    var nav = document.querySelector('[data-ds-anchors]');
    if (!nav || !('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var map = {};
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) map[t.id] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && map[e.target.id]) {
          links.forEach(function (l) { l.classList.remove('is-current'); l.removeAttribute('aria-current'); });
          map[e.target.id].classList.add('is-current');
          map[e.target.id].setAttribute('aria-current', 'true');
          map[e.target.id].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  /* Barre d'achat fixe : visible quand le bouton principal n'est plus à l'écran */
  function initSticky() {
    var bar = document.querySelector('[data-ds-sticky]');
    if (!bar) return;
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var mainBtn = form && form.querySelector('[type="submit"]');
    var btn = bar.querySelector('[data-ds-sticky-add]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        if (form && form.requestSubmit) { e.preventDefault(); form.requestSubmit(mainBtn || undefined); }
      });
    }
    if (!mainBtn || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); document.body.classList.add('ds-has-sticky'); return; }
    document.body.classList.add('ds-has-sticky');
    var footer = document.querySelector('.ds-footer');
    var mainVisible = true, footerVisible = false;
    function update() { bar.classList.toggle('is-visible', !mainVisible && !footerVisible); }
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; update(); }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
  }

  /* Sommaire automatique des articles */
  function initToc() {
    var toc = document.querySelector('[data-ds-toc]');
    var content = document.querySelector('.article-template__content');
    if (!toc || !content) return;
    var heads = content.querySelectorAll('h2');
    if (heads.length < 3) { toc.remove(); return; }
    var ol = toc.querySelector('ol');
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'partie-' + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
    });
    toc.hidden = false;
  }

  function initAll(root) {
    initReveal(root); initTabs(root); initFaq(root); initVideos(root); initDelivery(root); initCalc(root); pauseSvg(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document); initAnchors(); initSticky(); initToc();
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
